<template>
    <trax-ui-simple-table :id="id" :header="0" :rows="rows" :cols="cols" :bus="bus" v-show="rows.length">
    </trax-ui-simple-table>
</template>

<script>
    export default {
    
        props: {
            id: { default: 'enac-atpl-dashboard-self-paced' },
        },

        data: function() {
            return {
                links: data.resources.links,
                files: data.resources.files,
                baseUrl: app_url+'polaris/api/front/learning-units/'+data.item.id+'/files/',
                cols: [{width: '60px', class: 'text-center'}, {}],
                rows: [],
                bus: new Vue()
            }
        },

        created() {
            this.updateRows()
        },

        methods: {
        
            updateRows: function() {

                for (var index in this.links) {
                    var link = this.links[index];
                    var row = [this.linkIcon(link), this.linkName(link)];
                    this.rows.push(row);
                }

                for (var index in this.files) {
                    var file = this.files[index];
                    var row = [this.fileExtension(file), this.fileName(file)];
                    this.rows.push(row);
                }
            },


            //------------------------------- rendering ----------------------------//


            linkIcon: function(link) {
                return '<a href="'+link.href+'" target="_blank"><i class="material-icons">link</i></a>';
            },

            linkName: function(link) {
                return '<a href="'+link.href+'" target="_blank">'+link.name+'</a>';
            },

            fileExtension: function(file) {
                var format = file.mime_type.split('/')[1];
                var span = '<span class="badge badge-default">'+format+'</span>';
                return '<a href="' + this.baseUrl + file.id + '" target="_blank">' + span + '</a>';
            },

            fileName: function(file) {
                return '<a href="' + this.baseUrl + file.id + '" target="_blank">' + file.name + '</a>';
            },
        }
    }
</script>
